/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Step_Check_TitleInputs */

const en_serve_step_check_title = /** @type {(inputs: Serve_Step_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sure it worked? Run the check`)
};

const id_serve_step_check_title = /** @type {(inputs: Serve_Step_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum yakin berhasil? Jalankan pemeriksaan`)
};

/**
* | output |
* | --- |
* | "Not sure it worked? Run the check" |
*
* @param {Serve_Step_Check_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_step_check_title = /** @type {((inputs?: Serve_Step_Check_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Step_Check_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_step_check_title(inputs)
	return en_serve_step_check_title(inputs)
});